import React, { ReactNode } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import './AnimatedSection.css';

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  animation?: 'fadeInUp' | 'fadeInLeft' | 'fadeInRight' | 'fadeIn' | 'scaleIn';
  delay?: number;
  duration?: number;
  threshold?: number;
}

export const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  className = '',
  animation = 'fadeInUp',
  delay = 0,
  duration = 0.6,
  threshold = 0.1,
}) => {
  const { ref, isIntersecting } = useScrollAnimation({ threshold });

  const animationStyle = {
    '--animation-delay': `${delay}s`,
    '--animation-duration': `${duration}s`,
  } as React.CSSProperties;

  const classes = [
    'animated-section',
    `animated-section--${animation}`,
    isIntersecting ? 'animated-section--visible' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div ref={ref} className={classes} style={animationStyle}>
      {children}
    </div>
  );
};

export default AnimatedSection;